"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRepeatedDigitText = exports.formatStringToNumber = exports.formatRemoveSpaces = void 0;
const formatRemoveSpaces = (str) => str.replace(/\s/g, '');
exports.formatRemoveSpaces = formatRemoveSpaces;
const formatStringToNumber = (str) => str.match(/\d/g)?.join('') || '';
exports.formatStringToNumber = formatStringToNumber;
const isRepeatedDigitText = (str) => /^(\d)\1*$/.test(str);
exports.isRepeatedDigitText = isRepeatedDigitText;
